module.exports = __webpack_public_path__ + "static/media/messaging.77a89c2e.svg";